export default __webpack_public_path__ + "static/media/1.de1727c0.png";